export const AUTH_CONFIG = {
  clientId: 'coQuRq71S7Um7KpM3xZr76XKb8vEjCMH',
  domain: 'acestowncar.auth0.com',
  callbackUrl: 'https://alpha.acestowncarservice.com/callback',
  apiUrl: 'https://twosteau-qa.acestowncarservice.com'
}



// WEBPACK FOOTER //
// ./src/auth/auth0-variables.js